import { logType } from '@/enums';
import BaseModel from '../BaseModel';

export default class CandidateLog extends BaseModel {
  static entity = 'candidateLogs';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      eventType: this.string(null).nullable(),
      comment: this.string(null).nullable(),
      createdAt: this.string(null).nullable(),
      type: this.string(logType.CANDIDATE),
      officeInterviewId: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchAllByCandidateId(id, key = null) {
        return this.model.handleFetching(
          () => this.get(`/candidates/${id}/log`),
          key || `all_by_candidate_${id}`,
        );
      },
      store(candidateId, payload) {
        return this.post(`candidates/${candidateId}/log`, payload);
      },
      destroy(logId) {
        return this.delete(`candidates/log/${logId}`, { delete: logId });
      },
    },
  }
}
